import { Injectable } from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class HeaderService {

  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();

  constructor() { }

  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

  public notifyRefresh(data: any={action:'refresh'}) {
    if (data) {
      this.notify.next(data);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/header.service.ts